<template>
	<div class="animated fadeIn">
		<b-card>
			<b-card-header>
				<i class="icon-menu mr-1"></i>IPC列表
				<div class="card-header-actions">
					<b-link @click="openEditor()" v-if="!cannotEdit"><i class="fa fa-plus"></i> 新增</b-link>&nbsp;
				</div>
			</b-card-header>
			<b-card-body v-if="!cannotEdit">
				<v-server-table :columns="columns" :data="data" :options="options" :theme="theme" ref="dataTable" id="dataTable">
					<div slot="child_row" slot-scope="props">
						<b-button variant="info" class="btn-pill" size="sm" v-if="!cannotEdit" @click="editRow(props.row.id, props.row)"><i class="fa fa-pencil"></i> 編輯</b-button> &nbsp;
						<b-button variant="danger" class="btn-pill" size="sm" v-if="!cannotEdit" @click="delRow(props.row.id, props.row.name)"><i class="fa fa-times"></i> 刪除</b-button> &nbsp;
						<b-button variant="warning" class="btn-pill" size="sm" @click="showIpcUpgrade(props.row.project_name)"><i class="fa fa-cloud-download"></i> 更新</b-button> &nbsp;
						<b-button variant="secondary" class="btn-pill" size="sm" @click="IpcReboot(props.row.name, props.row.project_name)"><i class="fa fa-power-off"></i> 重啟</b-button> &nbsp;
					</div>
				</v-server-table>
			</b-card-body>
		</b-card>

		<b-modal title="刪除裝置" size="sm" v-model="delRowShowModal" @ok="submitDelRow(delRowId)" ok-title="確定" cancel-title="取消">
			{{delRowMsg}}
		</b-modal>

		<b-modal title="編輯器" size="lg" class="modal-info" v-model="showEditorModal" @ok="submitRecord" ok-title="儲存" cancel-title="取消" :ok-disabled="$v.record.$invalid">
			<b-form>
				<h1>IPC資料</h1>
				<p class="text-muted">綠框為必填</p>
				<b-input-group class="mb-3">
					<b-input-group-prepend>
						<b-input-group-text><i class="fa fa-clone"></i> 名稱</b-input-group-text>
					</b-input-group-prepend>
					<b-form-input type="text" 
					class="form-control" 
					placeholder="名稱" 
					v-model.lazy.trim="$v.record.name.$model"
					v-focus
					:state="chkState('name')"
					aria-describedby="invalidNameFeedback"/>
					<b-form-invalid-feedback id="invalidNameFeedback">名稱必填</b-form-invalid-feedback>
				</b-input-group>

				<b-input-group class="mb-3">
					<b-input-group-prepend>
						<b-input-group-text><i class="fa fa-clone"></i> ProjectName</b-input-group-text>
					</b-input-group-prepend>
					<b-form-input type="text" 
					class="form-control" 
					placeholder="ProjectName" 
					v-model.lazy.trim="$v.record.project_name.$model"
					:state="chkState('project_name')"
					aria-describedby="invalidPNFeedback"/>
					<b-form-invalid-feedback id="invalidPNFeedback">ProjectName必填</b-form-invalid-feedback>
				</b-input-group>

				<b-input-group class="mb-3">
					<b-input-group-prepend>
						<b-input-group-text><i class="icon-notebook icon"></i></b-input-group-text>
					</b-input-group-prepend>
					<b-form-textarea
					v-model.lazy.trim="record.remarks"
					placeholder="備註"
					:rows="3"
					:max-rows="6">
					</b-form-textarea>
				</b-input-group>
			</b-form>
		</b-modal>

		<b-modal title="IPC更新" size="lg" class="modal-info" v-model="showIpcUpgradeModal" @ok="IpcUpgrade" ok-title="更新" cancel-title="取消" :ok-disabled="$v.ipc.$invalid">
			<b-form>
				<h1>版本更新</h1>
				<p class="text-muted">綠框為必填</p>
				<b-input-group class="mb-3">
					<b-input-group-prepend>
						<b-input-group-text><i class="fa fa-clone"></i> Version</b-input-group-text>
					</b-input-group-prepend>
					<b-form-input type="text" 
					class="form-control" 
					placeholder="Version" 
					v-model.lazy.trim="$v.ipc.version.$model"
					:state="chkIpcState('version')"
					aria-describedby="invalidVersionFeedback"/>
					<b-form-invalid-feedback id="invalidVersionFeedback">格式範例: v20260101</b-form-invalid-feedback>
				</b-input-group>
			</b-form>
		</b-modal>
	</div>
</template>

<script>
import Vue from 'vue'
import {ServerTable, Event} from 'vue-tables-2'
import { required, minLength, between, email, minValue, integer } from 'vuelidate/lib/validators'
import config from '@/config/global'
import notifications from '@/config/notifications'
import jQuery from 'jquery'

import io from 'socket.io-client'
import _ from 'lodash'
import moment from 'moment-timezone'
import QRious from 'qrious'
import VueCtkDateTimePicker from 'vue-ctk-date-time-picker'

const encrypt    = config.encrypt;
const decrypt    = config.decrypt;
const admin_root = config.admin_root;

let $socket = null;

const clean_form = {
	name:'',
	project_name:'',
	remarks: '',
};

const ipc_clean_form = {
	version:'',
};

Vue.use(ServerTable)

export default {
	name: 'ipc_list',
	notifications,
	components: {
		ServerTable,
		Event,
	},
	data(){
		let app = this;
		let cannotEdit = app.$state.$get('ccff') === 'N/A' ? false : true;

		return {
			cannotEdit,
			showLogList: false,
			selected_row: null,
			selected_project_name: null,
			editRowId: null,
			record: Object.assign({}, clean_form),
			ipc: Object.assign({}, ipc_clean_form),
			showEditorModal: false,
			showIpcUpgradeModal: false,
			delRowShowModal: false,
			delRowId: 0,
			delRowMsg: '',
			columns: ['name', 'project_name', 'version', 'remarks', 'created'],
			data: [],
			options: {
				debounce: 86400000, // 停止預設的即時搜尋
				headings: {
					name:  '名稱',
					project_name: 'ProjectName',
					project_name: '版本',
					remarks: '備註',
					created: '建立時間'
				},
				orderBy: {
					column: 'created',
					ascending: false
				},
				sortable: ['name', 'project_name', 'version', 'created'],
				filterable: ['name', 'project_name', 'version'],
				sortIcon: { base:'fa', up:'fa-sort-asc', down:'fa-sort-desc', is:'fa-sort' },
				pagination: {
					chunk: 5,
					edge: false,
					nav: 'scroll'
				},
				perPage: 25,
				requestFunction(data) {
					let action = `${admin_root}/get_list/Ipc`;
					let params = {
						keyset: 'mqtt'
					};

					let ccff = this.$state.$get('ccff');
					if(ccff){
						params['ccff'] = ccff;
					}

					for(let col in data){
						params[col] = ''+data[col];
					}

					return fetch(action, {
						method: 'POST',
						headers: {
						'Content-Type': 'application/json',
						'Authorization': 'Bearer ' + app.$state.$get('adminuser').token
						},
						body: JSON.stringify(params)
					}).then(res => res.json()).then(result => {
						return {
						data: result.data || [],
						count: result.count || 0
						};
					}).catch(error => {
						return {
						data: [],
						count: 0
						};
					});
				}//eo requestFunction
			},
			useVuex: false,
			theme: 'bootstrap4',
			template: 'default'
		};//eo return
	},//eo data

	mounted(){
		let app = this;

		// Search field 按下Enter後開始搜尋
		this.$nextTick(() => {
			let searchInput = document.querySelector('.VueTables__search-field input');
			if (searchInput) {
				// 取消 Vue Tables 內部的即時搜尋
				/*searchInput.addEventListener('input', (event) => {
					console.info('searchInput event:', event);
				}, true); // 捕獲模式，確保先執行*/

				// 監聽 Enter 鍵，才真正搜尋
				searchInput.addEventListener('keyup', (event) => {
					//console.info('keyup: ', event.key);
					//this.showSuccess({message:`key: ${event.key}`});
					if (event.key === "Enter" || event.key === "Go" || event.key === "Search") {
						this.$refs.dataTable.setFilter(searchInput.value);

						//強制清除 Vue Tables 內部的 debounce 計時器
						//this.$refs.dataTable.query = searchInput.value; // 直接覆寫內部值，避免 24 小時後觸發
					}
				});

				// 監聽 "失去焦點" (按 "下一步" 後，強制搜尋)
				searchInput.addEventListener('blur', () => {
					//console.info('blur event: 搜尋觸發');
					//this.showSuccess({message:'blur event: 搜尋觸發'});
					this.$refs.dataTable.setFilter(searchInput.value);
				});
			}
		});
	},

	methods: {
		editRow(row_id, row) {
			this.selected_row = row;
			this.openEditor(row_id);
			this.record = Object.assign({}, this.selected_row);
		},//eo editRow

		delRow(row_id, name) {
			// console.info('del row_id:', row_id);
			this.delRowShowModal = row_id ? true : false;
			this.delRowId        = row_id;
			this.delRowMsg       = `您確定要刪除${name}嗎？`;
		},//eo delRow

		submitDelRow(row_id) {
			let app    = this;
			let action = `${admin_root}/update_ipc`;
			let params = {
				keyset: 'mqtt',
				record: encodeURIComponent(encrypt(JSON.stringify({
					id: row_id,
					field: 'valid',
					value: 0,
					value_type: 'int'
				})))
			};

			fetch(action, {
				method: 'POST',
				headers: {
					'Content-Type': 'application/json',
					'Authorization': 'Bearer ' + app.$state.$get('adminuser').token
				},
				body: JSON.stringify(params)
			}).then(res => res.json()).then(result => {
				if(result.success){
					app.showSuccess({
						title: '資料更新成功',
						message: result.message
					});

					app.$refs['dataTable'].refresh();
				} else {
					app.showError({
						title: '資料更新失敗',
						message: result.message
					});
				}
			}).catch(error => {
				app.showError({
					title: '資料更新失敗',
					message: error
				});
			});
		},

		chkState(val) {
			const field = this.$v.record[val];

			// console.info('this.$v.record[val]:', this.$v.record[val], ', v:', field.value);

			return !field.$dirty || !field.$invalid;
		},

		chkIpcState(val) {
			const field = this.$v.ipc[val];

			// console.info('this.$v.ipc[val]:', this.$v.ipc[val], ', v:', field.value);

			return !field.$dirty || !field.$invalid;
		},

		openEditor(row_id){
			this.editRowId       = row_id;
			this.showEditorModal = true;
			this.$v.record.$reset();
			let app        = this;

			if(row_id && app.selected_row){
				//do nothing
			} else {
				app.record       = Object.assign({}, clean_form);
				app.selected_row = null;
				app.row_id		 = null;
			}
		},

		IpcReboot(target_name, target_project_name) {
			let app = this;
			let msg = '';
			msg = `您確定要重開${target_name}嗎？`;
			if (window.confirm(msg)) {
				let project_name = encodeURIComponent(config.encrypt(target_project_name, config.ffkey, config.ffiv));
				let action = `${config.api_root}/ipc_reboot`;

				fetch(action, {
					method: 'POST',
					headers: {
						'Content-Type': 'application/json',
						'Authorization': 'Bearer ' + this.$state.$get('adminuser').token
					},
					body: JSON.stringify({
						keyset: 'mqtt',
						project_name: project_name
					})
				}).then(res => res.json()).then(result => {
					if(result.success){
						app.showSuccess({
							title: 'IPC重啟',
							message: result.message ? result.message : 'IPC重啟成功'
						});
					} else {
						app.showError({
							title: 'IPC重啟',
							message: result.message ? result.message : 'IPC重啟失敗，請稍後再試'
						});
					}
				}).catch(err => {
					app.showError({
						title: 'IPC重啟',
						message: result.message ? result.message : 'IPC重啟失敗，請稍後再試'
					});
				});
			}
		},

		IpcUpgrade() {
			let app = this;
			this.$v.ipc.$touch();

			if (this.$v.ipc.$invalid) {
				this.showError({message:"請填入版本號", timeout: 1000});
				return false;
			}

			let project_name = encodeURIComponent(config.encrypt(app.selected_project_name, config.ffkey, config.ffiv));
			let version = encodeURIComponent(config.encrypt(app.ipc.version, config.ffkey, config.ffiv));
			let action = `${config.api_root}/ipc_upgrade`;

			fetch(action, {
				method: 'POST',
				headers: {
					'Content-Type': 'application/json',
					'Authorization': 'Bearer ' + this.$state.$get('adminuser').token
				},
				body: JSON.stringify({
					keyset: 'mqtt',
					project_name: project_name,
					version: version
				})
			}).then(res => res.json()).then(result => {
				if(result.success){
					app.showSuccess({
						title: 'IPC更新',
						message: result.message ? result.message : 'IPC更新送出成功'
					});
				} else {
					app.showError({
						title: 'IPC更新',
						message: result.message ? result.message : 'IPC更新送出失敗，請稍後再試'
					});
				}
			}).catch(err => {
				app.showError({
					title: 'IPC更新',
					message: result.message ? result.message : 'IPC更新送出失敗，請稍後再試'
				});
			});
		},

		showIpcUpgrade(target_project_name) {
			this.selected_project_name = target_project_name;
			this.$v.ipc.$reset();
			this.ipc = Object.assign({}, ipc_clean_form);
			this.showIpcUpgradeModal = true;
		},//eo editRow

		submitRecord(event) {
			let app    = this;
			let row_id = app.editRowId;
			this.$v.record.$touch();

			if (this.$v.record.$invalid) {
				this.showError({message:'請輸入必填欄位', title:'資料錯誤'});
				return false;
			}

			if(this.record.remarks == '') {
				this.record.remarks = null;
			}

			let to_save = Object.assign({}, this.record);

			if(row_id){
				to_save['id'] = row_id;
			}

			/*if (to_save['charge_first'] && to_save['charge_first']['value'] !== undefined) {
			to_save['charge_first'] = to_save['charge_first']['value'];
			}*/

			to_save = encodeURIComponent(encrypt(JSON.stringify(to_save)));

			let action = `${admin_root}/save_ipc`;
			let params = {
				keyset: 'mqtt',
				record: to_save
			};

			fetch(action, {
				method: 'POST',
				headers: {
				'Content-Type': 'application/json',
				'Authorization': 'Bearer ' + this.$state.$get('adminuser').token
				},
				body: JSON.stringify(params)
			}).then(res => res.json()).then(result => {
				if(result.success){
					app.showSuccess({
						title: '成功',
						message: '資料成功儲存'
					});
					app.$refs['dataTable'].refresh();
					app.record = Object.assign({}, clean_form);
					app.$v.record.$reset();
				} else {
					if (event) {
						event.preventDefault();
					}
					app.showError({
						title: '錯誤',
						message: '無法儲存資料，請稍後再試'
					});
					app.$refs['dataTable'].refresh();
				}
			}).catch(error => {
				if (event) {
					event.preventDefault();
				}
				app.showError({
					title: '錯誤',
					message: '無法儲存資料，請稍後再試'
				});
				app.$refs['dataTable'].refresh();
			});
		},
	},

	validations: {
		record: {
			name: {
				required,
				minLength: minLength(2)
			},
			project_name: {
				required,
				minLength: minLength(2),
			},
		},
		ipc: {
			version: {
				required,
				minLength: minLength(9)
			}
		}
	},//eo validations
};
</script>
<style lang="scss">
.card-body{padding:0;}
.checkbox-container {display: flex;}
.checkbox-container .custom-checkbox {margin-right: 10px;}
.add-btn{}
.help-text{margin-top: 0.5rem; margin-left: 0.8rem;}
.multiselect__input{width:100%;border:none;}
#qrcode-canvas{
	display:inline-block;
	margin: auto;
}
#dataTable {
	width: 95%;
	margin: 0 auto;
	margin-top: 0.5rem;
	font-size: 0.75rem;

	.VuePagination {
	  text-align: center;
	  justify-content: center;
	}

	.vue-title {
	  text-align: center ;
	  margin-bottom: 10px;
	}

	.VueTables__search-field {
	  display: flex;
	}
	.VueTables__search-field input {
	  margin-left: 0.25rem;
	}

	.VueTables__limit-field {
	  display: flex;
	}

	.VueTables__limit-field select {
	  margin-left: 0.25rem !important;
	}

	.VueTables__table th {
	  text-align: center;
	}

	.VueTables__child-row-toggler {
	  width: 16px;
	  height: 16px;
	  line-height: 16px;
	  display: block;
	  margin: auto;
	  text-align: center;
	}

	.VueTables__child-row-toggler--closed::before {
	  content: "+";
	}

	.VueTables__child-row-toggler--open::before {
	  content: "-";
	}

	.VueTables__sortable {
		padding: 0.25rem;
	}
}
.modal .modal-xl {
	max-width: 90% !important;
    width: 90% !important;
}
.custom-table th,
.custom-table td {
	text-align: center;
	vertical-align: middle;
	padding: 1px;
}
.custom-table-for-week th,
.custom-table-for-week td {
	text-align: center;
	vertical-align: middle;
	padding: 1px;
}
.device-list-clickable-text {
	cursor: pointer;
	transition: background-color 0.3s, color 0.3s;
	color: black !important;
	text-decoration: none !important;
}
.device-list-clickable-text.clicked {
	background-color: #007bff;
	color: white !important;
}
.top-up-btn-sm{
	height: 3rem;
	max-width: 98%;
	min-width: 98%;
	margin: 0.5px 0px;
}
.custom-padding {
	padding: 0px;
}

</style>
